const EXPANDED_CLASS = 'is-expanded';

const MANUALS = {
  'download-manual': {
    url: 'https://cdn.invictawatch.com/www/files/warranty-manual.pdf',
    filename: 'manual.pdf',
  },
  'download-manual-techno': {
    url: 'https://cdn.shopify.com/s/files/1/0351/6602/7916/files/warranty-manual_f3a3f9ce-d45c-4019-82e2-ce8983ca2a68.pdf?v=1633737096',
    filename: 'manualTechnoMarine.pdf',
  },
  'download-manual-glycine': {
    url: 'https://cdn.shopify.com/s/files/1/0351/6602/7916/files/GL_MANUAL_USERS_AUTOMATIC_104253_Clycine.pdf?v=1643230847',
    filename: 'manualGlycine.pdf',
  },
};

const MANUAL_SELECTOR = Object.keys(MANUALS)
  .map((name) => `.${name}`)
  .join(',');

async function downloadManual(trigger, manual) {
  if (trigger.dataset.downloading === 'true') return;
  trigger.dataset.downloading = 'true';

  try {
    const response = await fetch(manual.url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = url;
    link.download = manual.filename;
    link.click();

    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch {
    window.open(manual.url, '_blank', 'noopener');
  } finally {
    delete trigger.dataset.downloading;
  }
}

function resolveTarget(trigger) {
  const selector = trigger.getAttribute('data-target') || trigger.getAttribute('href');
  if (!selector || !selector.startsWith('#') || selector.length < 2) return null;
  return document.querySelector(selector);
}

function activateTab(trigger) {
  const pane = resolveTarget(trigger);
  const content = pane?.parentElement;
  if (!content) return;

  const item = trigger.closest('li');
  const list = trigger.closest('.nav-tabs');

  if (item && list) {
    list.querySelectorAll(':scope > li').forEach((sibling) => {
      const selected = sibling === item;
      sibling.classList.toggle('active', selected);
      sibling.querySelector('a')?.setAttribute('aria-expanded', String(selected));
    });
  }

  content.querySelectorAll(':scope > .tab-pane').forEach((sibling) => {
    const selected = sibling === pane;
    sibling.classList.toggle('active', selected);
    sibling.classList.toggle('in', selected);
  });
}

function setCollapsed(panel, collapsed) {
  panel.classList.toggle('in', !collapsed);

  document
    .querySelectorAll(
      `[data-toggle="collapse"][href="#${panel.id}"], [data-toggle="collapse"][data-target="#${panel.id}"]`
    )
    .forEach((trigger) => {
      trigger.classList.toggle('collapsed', collapsed);
      trigger.setAttribute('aria-expanded', String(!collapsed));
    });
}

function toggleCollapse(trigger) {
  const panel = resolveTarget(trigger);
  if (!panel) return;

  const willOpen = !panel.classList.contains('in');
  const parentSelector = trigger.getAttribute('data-parent');
  const parent = parentSelector ? document.querySelector(parentSelector) : null;

  if (parent && willOpen) {
    parent.querySelectorAll('.collapse.in').forEach((open) => setCollapsed(open, true));
  }

  setCollapsed(panel, !willOpen);
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const tab = event.target.closest('[data-toggle="tab"]');
  if (tab) {
    event.preventDefault();
    activateTab(tab);
    return;
  }

  const collapse = event.target.closest('[data-toggle="collapse"]');
  if (collapse) {
    event.preventDefault();
    toggleCollapse(collapse);
    return;
  }

  const toggle = event.target.closest('.cta-product-description');
  if (toggle) {
    toggle.closest('.product-description')?.classList.toggle(EXPANDED_CLASS);
    return;
  }

  const trigger = event.target.closest(MANUAL_SELECTOR);
  if (!trigger) return;

  const name = Object.keys(MANUALS).find((key) => trigger.classList.contains(key));
  if (!name) return;

  event.preventDefault();
  downloadManual(trigger, MANUALS[name]);
});
